import { SignupStep } from '#sign-up/components/SignUp/types';

export const Faq = ({ step }: { step: SignupStep }) => {
  return (
    <div className="faq">
      <br />
      <h1>FAQ</h1>
      <div className="faq-content">
        <div>
          {step === SignupStep.Company && (
            <>
              <b>How do you keep my information secure?</b>
              <br />
              <p>
                We take security seriously. This ensures your sensitive information stays private and protected. See our{' '}
                <a href="https://epaypolicy.com/privacy/" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>
                .
              </p>
            </>
          )}
          {step === SignupStep.Controllers && (
            <>
              <b>I&apos;m a sole proprietor-why am I entering information again?</b>
              <br />
              <p>
                As a sole proprietor, your business and personal details are the same. While this may feel repetitive,
                it&apos;s required for verification and security purposes.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
